// User bucketing service for consistent feature rollouts
export class UserBucketService {
  private static instance: UserBucketService;

  static getInstance(): UserBucketService {
    if (!UserBucketService.instance) {
      UserBucketService.instance = new UserBucketService();
    }
    return UserBucketService.instance;
  }

  // Deterministic user bucketing (0-99) for consistent rollout
  getUserBucket(userId: string, featureKey: string): number {
    const hash = this.simpleHash(`${userId}-${featureKey}`);
    return hash % 100;
  }

  // Check if user is in rollout percentage
  isUserInRollout(
    userId: string,
    featureKey: string,
    rolloutPercentage: number,
  ): boolean {
    if (rolloutPercentage >= 100) return true;
    if (rolloutPercentage <= 0) return false;

    const bucket = this.getUserBucket(userId, featureKey);
    return bucket < rolloutPercentage;
  }

  // Assign user to experiment variant based on percentage distribution
  assignVariant(
    userId: string,
    experimentKey: string,
    variants: Record<string, number>,
  ): string | undefined {
    const bucket = this.getUserBucket(userId, experimentKey);

    let cumulativePercentage = 0;
    for (const [variantName, percentage] of Object.entries(variants)) {
      cumulativePercentage += percentage;
      if (bucket < cumulativePercentage) {
        return variantName;
      }
    }

    return undefined;
  }

  // Simple hash function for consistent bucketing
  private simpleHash(str: string): number {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash; // Convert to 32-bit integer
    }
    return Math.abs(hash);
  }
}
